/** Helpers for gifting-page and give-a-gift share flows. */

export function isMobileDevice() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export function canUseNativeShare(shareData) {
    if (typeof navigator.share !== 'function' || !isMobileDevice()) {
        return false;
    }
    if (typeof navigator.canShare === 'function') {
        return navigator.canShare(shareData);
    }
    return true;
}

export function getGiftingPageUrl(slug, wfItemId) {
    return wfItemId
        ? `https://www.greatestgiftapp.com/gifts/${slug}`
        : `https://app.greatestgiftapp.com/registry/${slug}`;
}

export function buildDefaultShareMessage(childName) {
    return `Hey, we're saving for ${childName}'s future! Here's a link for you to invest in ${childName}'s future through Greatest Gift.`;
}

export function getGiveAGiftShareUrl(childName, user) {
    const params = new URLSearchParams();
    params.set('Gift_for', childName);
    if (user?.first_name) params.set('Send_to', user.first_name);
    if (user?.email) params.set('send_to_email', user.email);
    params.set('channel', 'email');
    return `https://app.GreatestGiftApp.com/give-a-gift?${params.toString()}`;
}

export function buildMailtoHref(message, url) {
    return `mailto:?body=${encodeURIComponent(`${message}\n\n${url}`)}`;
}

export function buildSmsHref(message, url) {
    return `sms:?&body=${encodeURIComponent(`${message}\n\n${url}`)}`;
}

/** Opens the native share sheet on mobile; returns true if share completed or user dismissed. */
export async function openNativeShare({ url, text, title, onChannelSelect }) {
    const shareData = { url, text, title };
    if (!canUseNativeShare(shareData)) {
        return false;
    }

    try {
        await navigator.share(shareData);
        if (onChannelSelect) onChannelSelect('native');
        return true;
    } catch (err) {
        // User closed the sheet — not an error.
        if (err?.name === 'AbortError') {
            return true;
        }
        return false;
    }
}
